import React from "react";

import GalleryExchange from "./GalleryExchange";
import GalleryImages from "./GalleryImages";
import GalleryActions from "./GalleryActions";
import GalleryComments from "./GalleryComments";

function Post({ post }: { post: any }) {
  return (
    <div className="md:container md:mx-auto md:px-3 flex flex-col pt-5 pb-10 gap-5 px-3">
      <div>
        <GalleryExchange
          postId={post.id}
          exchangeTitle={post.exchange}
          exchangeSafe={post.exchange.titleSafe}
          title={post.title}
          titleSafe={post.titleSafe}
          exchange={post.exchange}
        />
      </div>
      <div className="order-2 md:order-4 grid grid-cols-12 gap-5">
        <div className="col-span-12 md:col-span-7 lg:col-span-8">
          <GalleryImages postId={post.id} images={post.images} />
        </div>
        <div className="col-span-12 md:col-span-5 lg:col-span-4 flex flex-col gap-3">
          <div suppressHydrationWarning>
            <GalleryActions post={post} />
          </div>
          <div>
            <GalleryComments postId={post.id} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Post;
